import { AxiosInstance } from 'axios';
import { QueryStringBuilder } from '@/shared/api-client/helpers';
import { IMotionCategory } from '@/shared/api-client/models/motion/motion-category';
import { IHierarchyNode } from '@/shared/api-client/models/hierarchy-node';
import { INewMotionCategories } from '../models/motion/new-motion-categories';
import { ArgumentValidator } from '@/shared/helpers';
import { IEditableMotionCategory } from '@/shared/api-client/models/motion/editable-motion-category';

export class MotionCategoryClient {

    constructor(private axiosClient: AxiosInstance) {

    }

    public get apiUrl() {
        return `/motionCategory`;
    }

    public async getHierarchy(activityId: string, cultureAlias: string, onlyActive = true): Promise<IHierarchyNode<IMotionCategory>[]> {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);
        ArgumentValidator.notNullOrEmpty(cultureAlias, `cultureAlias`);

        try {
            const url = new QueryStringBuilder()
                .withCultureAliasIfNotEmpty(cultureAlias)
                .withBooleanQuery(`onlyActive`, onlyActive)
                .build(`${this.apiUrl}/${activityId}/hierarchy`);

            const response = await this.axiosClient.get(
                url,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public async create(activityId: string, documentIdentifier: string, newMotion: INewMotionCategories): Promise<IMotionCategory[]> {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);
        ArgumentValidator.notNullOrEmpty(documentIdentifier, `documentIdentifier`);
        ArgumentValidator.notNullOrEmpty(newMotion, `newMotion`);

        try {

            return await this.axiosClient.post(
                `${this.apiUrl}/${activityId}/${documentIdentifier}`,
                newMotion,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public async update(activityId: string, documentIdentifier: string, id: string, editableMotionCategory: IEditableMotionCategory): Promise<IMotionCategory[]> {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);
        ArgumentValidator.notNullOrEmpty(documentIdentifier, `documentIdentifier`);
        ArgumentValidator.notNullOrEmpty(id, `id`);
        ArgumentValidator.notNullOrEmpty(editableMotionCategory, `newMotion`);

        try {

            return await this.axiosClient.put(
                `${this.apiUrl}/${activityId}/${documentIdentifier}/${id}`,
                editableMotionCategory,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public async delete(activityId: string, documentIdentifier: string, id: string): Promise<void> {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);
        ArgumentValidator.notNullOrEmpty(documentIdentifier, `documentIdentifier`);
        ArgumentValidator.notNullOrEmpty(id, `id`);

        const response = await this.axiosClient.delete(`${this.apiUrl}/${activityId}/${documentIdentifier}/${id}`);

        return response.data;
    }
}
